import React, {Component} from 'react';
import AuthService from "../services/auth.service";



class Header extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            loading:false,
            id :[]
          };
    }
    logOut= e => {
       // alert("ok")
        e.preventDefault();
        AuthService.logout();
           // const { history } = this.props;
           // this.props.history.push("/");
            //window.location.reload();
         window.location.href = "/";
    }

    async componentDidMount(){
       
        AuthService.getCurrentUser();
        const user = AuthService.getCurrentUser();
        this.setState({ id:user })
        //console.log(user)
            if(!user){
                this.setState({ loading:false });
               // window.location.href = "/";
            }  
            else{
                this.setState({ loading:true });
            } 
    }

  render() {
    //AuthService.getCurrentUser();
    //const user = AuthService.getCurrentUser();
return <div className="nk-header nk-header-fixed is-light">
                    <div className="container-lg wide-xl">
                        <div className="nk-header-wrap">
                            <div className="nk-header-brand">
                                <a href="/portal" className="logo-link">
                                   <img className="logo-dark logo-img" src="/images/hrlogo.png" srcset="/images/hrlogo.png" alt="logo-dark" width=""/>
                                    <img className="logo-dark logo-img" src="/images/hrlogo.png" srcset="/images/hrlogo.png" alt="logo-dark"/>
                                   {/*  <!--<span className="nio-version">SERVICE SOCIETY</span>--> */}
                                </a>
                            </div>{/* <!-- .nk-header-brand --> */}
{this.state.loading ?       <div className="nk-header-tools">
                                <ul className="nk-quick-nav">
                                    <li className="dropdown user-dropdown">
                                        <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                                            <div className="user-toggle">
                                                <div className="user-avatar sm">
                                                    <em className="icon ni ni-user-alt"></em>
                                                </div>
                                                <div className="user-name dropdown-indicator d-none d-sm-block">{this.state.id.full_name}</div>
                                            </div>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-md dropdown-menu-right dropdown-menu-s1">
                                            <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                                                <div className="user-card">
                                                    {/* <div className="user-avatar">
                                                        <span>AB</span>
                                                    </div> */}
                                                    <div className="user-info">
                                                        <span className="lead-text">{this.state.id.full_name}</span>
                                                        <span className="sub-text">{this.state.id.uid}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dropdown-inner">
                                                <ul className="link-list">
                                                    <li><a href="/profile"><em className="icon ni ni-user-alt"></em><span>View Profile</span></a></li>
                                                </ul>
                                            </div>
                                            <div className="dropdown-inner">
                                                <ul className="link-list">
                                                    <li><a href="#" type="button" onClick={this.logOut}><em className="icon ni ni-signout"></em><span>Sign out</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>{/* <!-- .dropdown --> */}
                                    {/*<li className="dropdown notification-dropdown">
                                        <a href="#" className="dropdown-toggle nk-quick-nav-icon mr-lg-n1" data-toggle="dropdown">
                                            <div className="icon-status icon-status-info"><em className="icon ni ni-bell"></em></div>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-xl dropdown-menu-right dropdown-menu-s1">
                                            <div className="dropdown-head">
                                                <span className="sub-title nk-dropdown-title">Notifications</span>
                                                <a href="#">Mark All as Read</a>
                                            </div>
                                            <div className="dropdown-body">
                                                <div className="nk-notification">
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-icon">
                                                            <em className="icon icon-circle bg-warning-dim ni ni-curve-down-right"></em>
                                                        </div>
                                                        <div className="nk-notification-content">
                                                            <div className="nk-notification-text">You have requested to <span>Widthdrawl</span></div>
                                                            <div className="nk-notification-time">2 hrs ago</div>
                                                        </div>
                                                    </div>
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-icon">
                                                            <em className="icon icon-circle bg-success-dim ni ni-curve-down-left"></em>
                                                        </div>
                                                        <div className="nk-notification-content">
                                                            <div className="nk-notification-text">Your <span>Deposit Order</span> is placed</div>
                                                            <div className="nk-notification-time">2 hrs ago</div>
                                                        </div>
                                                    </div>
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-icon">
                                                            <em className="icon icon-circle bg-warning-dim ni ni-curve-down-right"></em>
                                                        </div>
                                                        <div className="nk-notification-content">
                                                            <div className="nk-notification-text">You have requested to <span>Widthdrawl</span></div>
                                                            <div className="nk-notification-time">2 hrs ago</div>
                                                        </div>
                                                    </div>
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-icon">
                                                            <em className="icon icon-circle bg-success-dim ni ni-curve-down-left"></em>
                                                        </div>
                                                        <div className="nk-notification-content">
                                                            <div className="nk-notification-text">Your <span>Deposit Order</span> is placed</div>
                                                            <div className="nk-notification-time">2 hrs ago</div>
                                                        </div>
                                                    </div>
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-icon">
                                                            <em className="icon icon-circle bg-warning-dim ni ni-curve-down-right"></em>
                                                        </div>
                                                        <div className="nk-notification-content">
                                                            <div className="nk-notification-text">You have requested to <span>Widthdrawl</span></div>
                                                            <div className="nk-notification-time">2 hrs ago</div>
                                                        </div>
                                                    </div>
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-icon">
                                                            <em className="icon icon-circle bg-success-dim ni ni-curve-down-left"></em>
                                                        </div>
                                                        <div className="nk-notification-content">
                                                            <div className="nk-notification-text">Your <span>Deposit Order</span> is placed</div>
                                                            <div className="nk-notification-time">2 hrs ago</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dropdown-foot center">
                                                <a href="#">View All</a>
                                            </div>
                                        </div>
                                    </li>*/}
                                    <li className="d-lg-none">
                                        <a href="#" className="toggle nk-quick-nav-icon mr-n1" data-target="sideNav"><em className="icon ni ni-menu"></em></a>
                                    </li>
                                </ul>{/* <!-- .nk-quick-nav --> */}
                            </div>: ""}
                            
                            
                            
                            {/* <!-- .nk-header-tools --> */}
                        </div>{/* <!-- .nk-header-wrap --> */}
                    </div>{/* <!-- .container-fliud --> */}
                </div>

    }
}
export default Header;